import type { SVGProps } from "react";
export interface AlphabetJIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AlphabetJIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AlphabetJIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.375 15.5V4a1.125 1.125 0 0 1 2.25 0v11.5A5.607 5.607 0 0 1 12 21.126c-2.44 0-4.818-1.58-5.57-3.889l1.07-.347 1.07-.348c.421 1.297 1.87 2.334 3.43 2.334a3.357 3.357 0 0 0 3.375-3.374Zm-8.224.32a1.125 1.125 0 0 1 1.418.72l-2.138.696c-.192-.59.13-1.224.72-1.416"
      />
    </svg>
  );
}
